import { uniq, sample, toLower, map } from 'lodash';

export const wordList = uniq(
    map(
        [
            'Angel',
            'Eyeball',
            'Pizza',
            'Angry',
            'Fireworks',
            'Pumpkin',
            'Baby',
            'Flower',
            'Rainbow',
            'Beard',
            'Flying saucer',
            'Recycle',
            'Bible',
            'Giraffe',
            'Sand castle',
            'Bikini',
            'Glasses',
            'Snowflake',
            'Book',
            'High heel',
            'Stairs',
            'Bucket',
            'Ice cream cone',
            'Starfish',
            'Bumble bee',
            'Igloo',
            'Strawberry',
            'Butterfly',
            'Lady bug',
            'Sun',
            'Camera',
            'Lamp',
            'Tire',
            'Cat',
            'Lion',
            'Toast',
            'Church',
            'Mailbox',
            'Toothbrush',
            'Crayon',
            'Night',
            'Toothpaste',
            'Dolphin',
            'Nose',
            'Truck',
            'Egg',
            'Olympics',
            'Volleyball',
            'Eiffel Tower',
            'Peanut',
            'Abraham Lincoln',
            'Kiss',
            'Pigtails',
            'Brain',
            'Kitten',
            'Playground',
            'Bubble bath',
            'Kiwi',
            'Pumpkin pie',
            'Buckle',
            'Lipstick',
            'Raindrop',
            'Bus',
            'Lobster',
            'Robot',
            'Car accident',
            'Lollipop',
            'Sand castle',
            'Castle',
            'Magnet',
            'Slipper',
            'Chain saw',
            'Megaphone',
            'Snowball',
            'Circus tent',
            'Mermaid',
            'Sprinkler',
            'Computer',
            'Minivan',
            'Statue of Liberty',
            'Crib',
            'Mount Rushmore',
            'Tadpole',
            'Dragon',
            'Music',
            'Teepee',
            'Dumbbell',
            'North pole',
            'Telescope',
            'Eel',
            'Nurse',
            'Train',
            'Ferris wheel',
            'Owl',
            'Tricycle',
            'Flag',
            'Pacifier',
            'Tutu',
            'Junk mail',
            'Piano',
            'Attic',
            'Glue',
            'Pocket watch',
            'Back seat',
            'Highchair',
            'Rock band',
            'Birthday',
            'Hockey',
            'Sasquatch',
            'Black hole',
            'Hotel',
            'Scrambled eggs',
            'Blizzard',
            'Jump rope',
            'Seat belt',
            'Burrito',
            'Koala',
            'Skip',
            'Captain',
            'Leprechaun',
            'Solar eclipse',
            'Chandelier',
            'Light',
            'Space',
            'Crib',
            'Mask',
            'Stethoscope',
            'Cruise ship',
            'Mechanic',
            'Stork',
            'Dance',
            'Mom',
            'Sunburn',
            'Deodorant',
            'Mr Potato Head',
            'Thread',
            'Facebook',
            'Pantyhose',
            'Tourist',
            'Flat',
            'Paper plate',
            'United States',
            'Frame',
            'Photo',
            'WiFi',
            'Full moon',
            'Pilgram',
            'Zombie',
            'Game',
            'Pirate',
        ],
        toLower,
    ),
);

export function generateWord(): string {
    return sample(wordList) || '';
}
